import React, { useState } from 'react';
import { connect } from 'react-redux';

import '../Style/style.scss';
import image from '../Images/33.jpg';

import validate from '../components/Form/validateInfo';
import useForm from '../components/Form/useForm';
import useBox from '../components/Form/useBox';
import useTable from '../components/Footers/useTable';

import PrimeContent from '../components/Content/PrimeContent/PrimeContent';
import Footer from '../components/Footers/Footer';
import PrimeFooter from '../components/Footers/PrimeFooter';

import Form from '../components/Form/Form';
import Common from '../components/Form/Common';
import ButtonPrime from '../components/Form/Button/ButtonPrime';
import Image from '../components/Form/Image';
import AvatarBox from '../components/Form/Image/AvatarBox';
import PhotosBox from '../components/Form/Image/PhotosBox';
import UploadBox from '../components/Form/Image/UploadBox';
import Overlay from '../components/Overlay';
import Sidebar from '../components/Sidebar';

const PrimePage = (props) => {
  const {mailBox, setMailBox} =  useTable();

  const {
    overlayToggle,
    avatarBoxToggle,
    uploadBoxToggle,
    photosBoxToggle,
    overlayActive,
    avatarBoxActive,
    uploadBoxActive,
    setAvatarBoxActive,
    setUploadBoxActive,
    photosBoxActive,
    setPhotosBoxActive,
    foldersActive,
    setfoldersActive,
    foldersToggle } = useBox();

  const {
    handleChange,
    handleSubmit,
    errors,
  } = useForm(submitForm, validate(props, true));

  const [isSubmitted, setIsSubmitted] = useState(false);
  function submitForm() {
    setIsSubmitted(true);
  }

  return (
    <div className='container'>
      <Sidebar/>

      <div className='content-left prime'>
        {/*if form is completed, show footer table with data*/}
        {!isSubmitted ? (
          <PrimeContent />
        ) : (
          <Footer mailBox={mailBox} setMailBox={setMailBox}>
            <PrimeFooter/>
          </Footer>
        )}
      </div>

      <div className='content-right'>
        <img className='content-right--image' src={image} alt="one" />
        <Form handleSubmit={handleSubmit}>
          <Common errors={errors}/>
          <Image
            overlayToggle={overlayToggle}
            avatarBoxToggle={avatarBoxToggle}
            uploadBoxToggle={uploadBoxToggle}
            photosBoxToggle={photosBoxToggle}
            foldersToggle={foldersToggle}
            setAvatarBoxActive={setAvatarBoxActive}
            setUploadBoxActive={setUploadBoxActive}
            setPhotosBoxActive={setPhotosBoxActive}
            errors={errors}
          />
          <ButtonPrime />
        </Form>
      </div>

      <Overlay overlayActive={overlayActive}>
          <AvatarBox
            handleChange={handleChange}
            avatarBoxToggle={avatarBoxToggle}
            avatarBoxActive={avatarBoxActive}
            overlayToggle={overlayToggle}
          />
          <UploadBox
            handleChange={handleChange}
            uploadBoxToggle={uploadBoxToggle}
            uploadBoxActive={uploadBoxActive}
            overlayToggle={overlayToggle}
          />
          <PhotosBox
            photosBoxToggle={photosBoxToggle}
            photosBoxActive={photosBoxActive}
            setPhotosBoxActive={setPhotosBoxActive}
            overlayToggle={overlayToggle}
            foldersActive={foldersActive}
            setfoldersActive={setfoldersActive}
            foldersToggle={foldersToggle}
          />
      </Overlay>
    </div>
  );
};

// send props to validate
function mapStateToProps(state) {
  return {
    user_name: state.user_reducer.user_name,
    user_surname: state.user_reducer.user_surname,
    user_position: state.user_reducer.user_position,
    user_email: state.user_reducer.user_email,
    user_phone: state.user_reducer.user_phone,
    user_image: state.user_reducer.user_image,
  }
}
export default connect(mapStateToProps)(PrimePage);